/**
 * Breakpoints unificati (analisi layout 2026-08-19).
 * sm 640 · md 1024 · lg 1280 · xl 1600
 * Alias mobile/desktop mantenuti per useDeviceType.
 */
export const BREAKPOINT_SM = 640;
export const BREAKPOINT_MD = 1024;
export const BREAKPOINT_LG = 1280;
export const BREAKPOINT_XL = 1600;
export const BREAKPOINT_MOBILE = 768;
export const BREAKPOINT_DESKTOP = 1025;
